import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "usage_star",
  "use": "usage_star-usage",
  "viewBox": "0 0 30 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 30 28\" id=\"usage_star\"><path d=\"m15.005 1.001 4.616 8.17 9.387 1.76-6.535 6.81 1.187 9.258-8.655-3.962-8.655 3.962 1.187-9.258-6.535-6.81 9.387-1.76 4.616-8.17\" style=\"fill:#fff;stroke:#fcb813;stroke-linejoin:round;stroke-width:2px;fill-rule:evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol